import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useBreadcrumb } from "features/breadcrumbs";
import PageHeader from "components/Page/PageHeader";
import { Col, Row } from "antd";
import RelatorioDemonstrativo from "./components/RelatorioDemonstrativo";
import ModalFiltros from "ui/components/Relatorio/ModalFiltros";
import useFiltroRelatorioReceitaDespesaAnual from "./components/RelatorioDemonstrativo/hooks/useFiltroRelatorioReceitaDespesaAnual";
import { useRelatorioDemonstrativoReceitaDespesaAnual } from "core/features/relatorios/hooks/useRelatorioDemonstrativoReceitaDespesaAnual";
import Container from "components/Container";
import { FaFilter } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import SelectMonthYear from "ui/components/Input/SelectMonthYear";
import moment from "moment";
import DashboardMovimentacoes from "components/RelatorioDemonstrativoReceitaDespesa/DashboardMovimentacoes";

function DemonstrativoReceitasDespesasAnual() {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { filtro, onChangeFiltro } = useFiltroRelatorioReceitaDespesaAnual();

  const { data, isLoading } =
    useRelatorioDemonstrativoReceitaDespesaAnual(filtro);

  const numeroFiltroSelecionados =
    (filtro.contaCategoriaIds?.length || 0) +
    (filtro.contaBancariaIds?.length || 0);

  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Demonstrativo Receitas e Despesas Anual",
      url: "/relatorios/financeiro/receitas-despesas-anual",
    },
  ]);

  return (
    <Container>
      <PageHeader
        title="Demonstrativo Receitas e Despesas Anual"
        extraButtonTitle="Filtrar"
        extraButtonOnClick={() => setIsOpenModal(true)}
        badge={!!numeroFiltroSelecionados}
        badgeValueExtraButton={numeroFiltroSelecionados}
        midComponent={
          <SelectMonthYear
            format="YYYY"
            picker="year"
            bg="white"
            value={moment(filtro.ano, "YYYY")}
            disabledDate={(date) => date.isBefore("2021-01-01")}
            onChange={(date) =>
              date &&
              onChangeFiltro({
                ano: date.format("YYYY"),
              })
            }
          />
        }
        iconExtraButton={
          <>
            <FaFilter size={14} />
            <Flex right="10px" top="14px" position="absolute">
              <AiOutlinePlus size={9} />
            </Flex>
          </>
        }
      />

      <Row gutter={32} align="bottom">
        <Col sm={24} md={24}>
          <DashboardMovimentacoes
            isLoading={isLoading}
            totais={data?.totais}
            dataFim={`${filtro.ano}-12-31`}
            showSaldo={false}
          />
        </Col>
      </Row>
      <Box>
        <RelatorioDemonstrativo
          data={data}
          filtro={filtro}
          isLoading={isLoading}
          onChangeFiltro={onChangeFiltro}
        />
      </Box>
      <ModalFiltros
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
        numeroFiltroSelecionados={numeroFiltroSelecionados}
      />
    </Container>
  );
}

export default DemonstrativoReceitasDespesasAnual;
